export default "__VITE_ASSET__ClCyQe$F__"